import styled from 'styled-components';

export const RegisterRepresentativeContainerUI = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 20px 0;

  gap: 10px;
`;

export const RegisterConfirmContainer = styled.div`
  padding: 50px;
  border: 1px solid #1064a3;
  background-color: #eef2f8;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-direction: column;
`;

export const ConfirmRegisterLayout = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: rgba(56, 72, 91, 0.8);
`;

export const ConfirmBlueLayout = styled.div`
  font-size: 40px;
  font-weight: 700;
  line-height: 39px;
  color: #1064a3;
`;
